import { Badge } from '@bambi/component-library/src/components/Badge/Badge';
import { isNil } from 'lodash-es';

import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';
import { Skeleton } from 'src/common/Skeleton';
import { getCancelReasonDisplay } from 'src/features/trip/management/cancel/CancelTripModal/cancellationReasons';
import { TripImportedBadge } from 'src/features/trip/management/TripImportedBadge';
import { TripStatusBadge } from 'src/features/trip/management/TripStatusBadge';

import { isDispatchTrip } from '../../../common/isDispatchTrip';

interface TripDetailsStatusProps {
  isTripDataLoading: boolean;
  tripData?: TripRead;
  trip:
    | DispatchTripRead
    | RunBambiRunTripRead
    | RunBambiRunReassignedTripRead
    | TripRead;
}

export function TripDetailsStatus({
  isTripDataLoading,
  trip,
  tripData,
}: TripDetailsStatusProps) {
  return (
    <div className="flex flex-col gap-1 py-2">
      <h4 className="text-sm font-bold">Status</h4>
      <div>
        {isTripDataLoading ? (
          <Skeleton />
        ) : (
          <span className="my-1 flex gap-2">
            <div className="flex flex-col gap-2">
              <div>
                <TripStatusBadge status={tripData?.status} />
              </div>

              {tripData?.canceled_reason && tripData.status === 'canceled' && (
                <span
                  data-testid="canceled-reason"
                  className="text-xs text-gray-500"
                >
                  <span className="font-bold">Reason:</span>{' '}
                  {getCancelReasonDisplay(tripData.canceled_reason)}
                </span>
              )}
            </div>

            {isDispatchTrip(trip) && !isNil(trip.timing?.is_on_time) && (
              <Badge
                color={trip.timing.is_on_time ? 'green' : 'yellow'}
                label={trip.timing.is_on_time ? 'on time' : 'delayed'}
              />
            )}
            {tripData && <TripImportedBadge trip={tripData} />}
          </span>
        )}
      </div>
    </div>
  );
}
